export default {
    version: 'latest',
    description: 'CloudKick Device Manager',
    format: 'onetable:1.1.0',
    params: {
        isoDates: true,
        nulls: false,
        typeField: '_type',
        timestamps: 'update'
    },
    indexes: {
        primary: {
            hash: 'pk',
            sort: 'sk',
            description: 'Primary index'
        },
        gs1: {
            hash: 'gs1pk',
            sort: 'gs1sk',
            project: 'all'
        }
    },
    process: {
        Broadcast: {
            enable: 'both',
            sync: 'down',
            show: true,
            mem: true
        },
        Command: {
            enable: 'both',
            sync: 'down',
            show: true
        },
        Device: {
            enable: 'both',
            sync: 'up',
            show: true
        },
        Log: {
            enable: 'both',
            sync: 'up',
            show: true,
            actions: true
        },
        Store: {
            enable: 'both',
            notify: 'default',
            sync: 'up',
            actions: true,
            delay: 0
        },
        SyncState: {
            enable: 'device',
            show: false
        },
        Event: {
            enable: 'both',
            sync: 'up',
            notify: 'default'
        },
        Notice: {
            enable: 'both',
            sync: 'down'
        },
        Mapping: {
            enable: 'both',
            sync: 'up',
            notify: 'default'
        },
        Port: {
            enable: 'both',
            sync: 'up',
            notify: 'default'
        },
        PortStats: {
            enable: 'both',
            sync: 'up',
            period: 5,
            metrics: [
                {
                    fields: [
                        'rxBytes',
                        'txBytes'
                    ],
                    dimensions: [
                        null,
                        'id'
                    ]
                }
            ]
        },
        Settings: {
            enable: 'device'
        },
        Stats: {
            enable: 'both',
            sync: 'up',
            period: 5
        },
        Vlan: {
            enable: 'both',
            sync: 'up',
            notify: 'default'
        }
    },
    models: {
        Broadcast: {
            pk: {
                type: 'string',
                value: 'bcast#${accountId}#${deviceId}',
                hidden: true
            },
            sk: {
                type: 'string',
                value: 'bcast#${key}',
                hidden: true
            },
            accountId: {
                type: 'string',
                required: true,
                readonly: true
            },
            created: {
                type: 'date',
                readonly: true
            },
            deviceId: {
                type: 'string',
                required: true,
                readonly: true
            },
            key: {
                type: 'string',
                required: true
            },
            value: {
                type: 'object',
                required: true
            },
            type: {
                type: 'string',
                required: true
            },
            updated: {
                type: 'date',
                readonly: true
            },
            expires: {
                type: 'date',
                ttl: true
            },
            _source: {
                type: 'string',
                hidden: true
            }
        },
        Command: {
            pk: {
                type: 'string',
                value: 'command#',
                hidden: true
            },
            sk: {
                type: 'string',
                value: 'command#${accountId}#${deviceId}#${id}',
                hidden: true
            },
            accountId: {
                type: 'string',
                required: true,
                readonly: true
            },
            created: {
                type: 'date',
                readonly: true
            },
            args: {
                type: 'object',
                required: true,
                default: {
                }
            },
            command: {
                type: 'string',
                required: true
            },
            deviceId: {
                type: 'string',
                required: true,
                readonly: true
            },
            description: {
                type: 'string'
            },
            expires: {
                type: 'date',
                ttl: true
            },
            id: {
                type: 'string',
                generate: 'ulid'
            },
            updated: {
                type: 'date',
                readonly: true
            },
            _source: {
                type: 'string',
                hidden: true
            }
        },
        Device: {
            pk: {
                type: 'string',
                value: 'd#${accountId}',
                hidden: true
            },
            sk: {
                type: 'string',
                value: 'd#${id}',
                hidden: true
            },
            accountId: {
                type: 'string',
                readonly: true,
                notes: 'Manage account ID'
            },
            connection: {
                type: 'string',
                notes: 'If the device is online or offline'
            },
            created: {
                type: 'date'
            },
            description: {
                type: 'string'
            },
            id: {
                type: 'string',
                required: true,
                readonly: true
            },
            model: {
                type: 'string'
            },
            name: {
                type: 'string'
            },
            product: {
                type: 'string',
                notes: 'Product Token'
            },
            state: {
                type: 'string',
                notes: 'Device state'
            },
            updated: {
                type: 'date',
                readonly: true
            },
            _source: {
                type: 'string',
                hidden: true
            }
        },
        Log: {
            pk: {
                type: 'string',
                value: 'l#${accountId}#${deviceId}',
                hidden: true
            },
            sk: {
                type: 'string',
                value: 'l#${id}',
                hidden: true
            },
            id: {
                type: 'string',
                generate: 'ulid',
                notes: 'Unique ID'
            },
            accountId: {
                type: 'string',
                required: true,
                readonly: true,
                notes: 'Owning account'
            },
            created: {
                type: 'date',
                readonly: true
            },
            deviceId: {
                type: 'string',
                required: true,
                readonly: true,
                notes: 'Owning device'
            },
            message: {
                type: 'string'
            },
            context: {
                type: 'object',
                default: {
                }
            },
            expires: {
                type: 'date',
                ttl: true
            },
            updated: {
                type: 'date',
                readonly: true
            },
            _source: {
                type: 'string',
                hidden: true
            }
        },
        Store: {
            pk: {
                type: 'string',
                value: 's#${accountId}#${deviceId}',
                hidden: true
            },
            sk: {
                type: 'string',
                value: 's#${key}',
                hidden: true
            },
            accountId: {
                type: 'string',
                required: true,
                readonly: true
            },
            created: {
                type: 'date',
                readonly: true
            },
            deviceId: {
                type: 'string',
                required: true,
                readonly: true
            },
            key: {
                type: 'string',
                required: true
            },
            value: {
                type: 'object',
                required: true
            },
            type: {
                type: 'string',
                required: true
            },
            updated: {
                type: 'date',
                readonly: true
            },
            expires: {
                type: 'date',
                ttl: true
            },
            _source: {
                type: 'string',
                hidden: true
            }
        },
        SyncState: {
            sk: {
                type: 'string',
                value: 'state#'
            },
            lastSync: {
                type: 'date',
                notes: 'Last time the device was synced with the cloud'
            },
            lastUpdate: {
                type: 'date',
                notes: 'Last time the device software was updated'
            }
        },
        Event: {
            pk: {
                type: 'string',
                value: 'device#${deviceId}'
            },
            sk: {
                type: 'string',
                value: 'event#${id}'
            },
            id: {
                type: 'string',
                generate: 'uid'
            },
            deviceId: {
                type: 'string',
                required: true
            },
            message: {
                type: 'string',
                required: true
            },
            severity: {
                type: 'string',
                required: true,
                enum: [
                    'info',
                    'warn',
                    'error',
                    'critical',
                    'fatal'
                ]
            },
            source: {
                type: 'string',
                required: true
            },
            subject: {
                type: 'string',
                required: true
            },
            timestamp: {
                type: 'date',
                required: true
            },
            updated: {
                type: 'date'
            },
            _source: {
                type: 'string',
                hidden: true
            }
        },
        Notice: {
            pk: {
                type: 'string',
                value: 'device#${deviceId}'
            },
            sk: {
                type: 'string',
                value: 'notice#${id}'
            },
            id: {
                type: 'string',
                generate: 'uid'
            },
            deviceId: {
                type: 'string',
                required: true
            },
            message: {
                type: 'string',
                required: true
            },
            timestamp: {
                type: 'date',
                required: true
            },
            updated: {
                type: 'date'
            },
            _source: {
                type: 'string',
                hidden: true
            }
        },
        Mapping: {
            pk: {
                type: 'string',
                value: 'device#${deviceId}'
            },
            sk: {
                type: 'string',
                value: 'mapping#${id}'
            },
            id: {
                type: 'string',
                generate: 'uid'
            },
            deviceId: {
                type: 'string',
                required: true
            },
            portId: {
                type: 'string',
                required: true
            },
            vlanId: {
                type: 'string',
                required: true
            },
            updated: {
                type: 'date'
            },
            _source: {
                type: 'string',
                hidden: true
            }
        },
        Port: {
            pk: {
                type: 'string',
                value: 'device#${deviceId}'
            },
            sk: {
                type: 'string',
                value: 'port#${id}'
            },
            id: {
                type: 'string',
                generate: 'uid'
            },
            deviceId: {
                type: 'string',
                required: true
            },
            enable: {
                type: 'boolean',
                default: true
            },
            duplex: {
                type: 'string',
                default: 'full'
            },
            flowControl: {
                type: 'boolean',
                default: true
            },
            jumbo: {
                type: 'boolean',
                default: true
            },
            name: {
                type: 'string'
            },
            negotiate: {
                type: 'boolean',
                default: true
            },
            speed: {
                type: 'number',
                default: 1000
            },
            status: {
                type: 'string',
                enum: [
                    'online',
                    'offline'
                ],
                default: 'online'
            },
            rxBytes: {
                type: 'number',
                default: 0
            },
            rxPackets: {
                type: 'number',
                default: 0
            },
            txBytes: {
                type: 'number',
                default: 0
            },
            txPackets: {
                type: 'number',
                default: 0
            },
            updated: {
                type: 'date'
            },
            _source: {
                type: 'string',
                hidden: true
            }
        },
        PortStats: {
            pk: {
                type: 'string',
                value: 'device#${deviceId}'
            },
            sk: {
                type: 'string',
                value: 'ptats#${id}'
            },
            id: {
                type: 'string'
            },
            deviceId: {
                type: 'string',
                required: true
            },
            rxBytes: {
                type: 'number',
                default: 0
            },
            rxPackets: {
                type: 'number',
                default: 0
            },
            txBytes: {
                type: 'number',
                default: 0
            },
            txPackets: {
                type: 'number',
                default: 0
            },
            updated: {
                type: 'date'
            },
            _source: {
                type: 'string',
                hidden: true
            }
        },
        Settings: {
            pk: {
                type: 'string',
                value: 'settings#${deviceId}'
            },
            sk: {
                type: 'string',
                value: 'settings#'
            },
            _source: {
                type: 'string',
                hidden: true
            }
        },
        Stats: {
            pk: {
                type: 'string',
                value: 'device#${deviceId}'
            },
            sk: {
                type: 'string',
                value: 'stats#'
            },
            deviceId: {
                type: 'string',
                required: true
            },
            io: {
                type: 'number',
                default: 0
            },
            temperature: {
                type: 'number',
                default: 0
            },
            activePorts: {
                type: 'number',
                default: 0
            },
            activeVlans: {
                type: 'number',
                default: 0
            },
            vlanStatus: {
                type: 'array'
            },
            updated: {
                type: 'date'
            },
            _source: {
                type: 'string',
                hidden: true
            }
        },
        Vlan: {
            pk: {
                type: 'string',
                value: 'device#${deviceId}'
            },
            sk: {
                type: 'string',
                value: 'vlan#${id}'
            },
            id: {
                type: 'string',
                generate: 'uid'
            },
            deviceId: {
                type: 'string',
                required: true
            },
            name: {
                type: 'string',
                required: true
            },
            description: {
                type: 'string'
            },
            status: {
                type: 'string',
                required: true,
                enum: [
                    'online',
                    'offline'
                ],
                default: 'online'
            },
            rxBytes: {
                type: 'number',
                default: 0
            },
            rxPackets: {
                type: 'number',
                default: 0
            },
            txBytes: {
                type: 'number',
                default: 0
            },
            txPackets: {
                type: 'number',
                default: 0
            },
            updated: {
                type: 'date'
            },
            _source: {
                type: 'string',
                hidden: true
            }
        }
    }
}

